export const ROUTESNAVBAR = {
	HOME: '/home',
	HOW_IT_WORKS: '/how-it-works',
	ABOUT_US: '/about-us',
	PRICING: '/pricing',
	LOGIN_REGISTER: '/login-register',
};

export const ROUTESCARDS = {
	AGENT_VIRTUAL: '/agent-virtual',
	CONSULTANT_VIRTUAL: '/consultant-virtual',
	DESIGN_VIRTUAL: '/designer-virtual',
};

export const LOGIN_REGISTER = {
	LOGIN_REGISTER_CHANGE: '/login-register-change',
	PACCHETTI_ACQUISITI: '/pacchetti-acquistati'
};